module.exports = __webpack_public_path__ + "img/bank.5d5a76c6.png";